import { __assign, __makeTemplateObject } from "tslib";
import React, { memo } from 'react';
import { ArrowLeft2, ArrowRight } from '@ringcentral/juno-icon';
import { combineProps, spacing, styled, } from '../../../foundation';
import { RcIconButton } from '../../Buttons/IconButton/IconButton';
var TablePaginationActionsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-left: ", ";\n"], ["\n  display: flex;\n  margin-left: ", ";\n"])), spacing(5));
export var RcTablePaginationActions = memo(function (props) {
    var onPageChange = props.onPageChange, page = props.page, count = props.count, rowsPerPage = props.rowsPerPage, className = props.className, backIconButtonProps = props.backIconButtonProps, nextIconButtonProps = props.nextIconButtonProps;
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var prevDisabled = page === 0;
    var nextDisabled = count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false;
    return (React.createElement(TablePaginationActionsWrapper, { className: className },
        React.createElement(RcIconButton, __assign({ symbol: ArrowLeft2, onClick: handleBackButtonClick, size: "medium", disabled: prevDisabled }, combineProps({ TooltipProps: { tooltipForceHide: prevDisabled } }, backIconButtonProps))),
        React.createElement(RcIconButton, __assign({ symbol: ArrowRight, onClick: handleNextButtonClick, size: "medium", disabled: nextDisabled }, combineProps({ TooltipProps: { tooltipForceHide: nextDisabled } }, nextIconButtonProps)))));
});
var templateObject_1;
